<template>
  <form name="form" @submit.prevent="login">
    <u-input type="text" class="form-control" placeholder="请输入用户名" name="username" v-model="username" autofocus tabindex="1">
      <span v-if="validation.hasError('username')" slot="right" class="input-error">{{validation.firstError('username')}}</span>
    </u-input>
    <u-input type="password" class="form-control" placeholder="请输入密码" name="password" v-model="password" tabindex="2">
      <span v-if="validation.hasError('password')" slot="right" class="input-error">{{validation.firstError('password')}}</span>
    </u-input>
    <u-button native-type="submit" style="margin-top: 40px">登录</u-button>
  </form>
</template>
<script>
import { mapActions } from 'vuex'
import { Validator } from 'simple-vue-validator'
import AV from 'leancloud-storage'
import { fetchUserData } from '@/store'
export default {
  data () {
    return {
      username: '',
      password: '',
      submitted: false
    }
  },
  validators: {
    username: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('用户名必填')
      }
    },
    password: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('密码必填')
      }
    }
  },
  methods: {
    ...mapActions(['updateUserFromAV']),
    login () {
      this.submitted = true
      this.$validate().then(isSuccess => {
        if (isSuccess) {
          AV.User.logIn(this.username, this.password).then(loginedUser => {
            this.updateUserFromAV(loginedUser)
            fetchUserData()
            this.$router.push('/')
          }).catch(error => {
            if (error.code === 1) {
              this.$toast(error.error || '失败次数超出限制')
            } else if (error.code === 210) {
              this.$toast('密码不正确')
            } else if (error.code === 211) {
              this.$toast('用户不存在')
            }
            console.log(error)
          })
        }
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?321704be